// @flow
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { openRebateTermsModal } from '../../actions/modals'
import PageHeader from '../../components/PageHeader'
import FaqTabs from '../../components/FaqTabs'
import Card from '../../components/Card'
import LinkButton from '../../components/LinkButton'

type Props = {
  openRebateTermsModal: Function
}

const Rebate = ({
  openRebateTermsModal // eslint-disable-line no-shadow
}: Props) => (
  <div>
    <Helmet title="Home Purchase Rebate" />
    <PageHeader text="We Appreciate Your Business">
      Kief Realty charges you nothing, provides you with professional and expert
      guidance when buying your home, and then essentially pays YOU for letting
      us work for you.
    </PageHeader>
    <FaqTabs />
    <div className="container">
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Kief Realty Commission Rebate FAQs</h2>
        <strong>Traditional real estate commissions explained</strong>
        <p>
          In our market areas, Realtors work in a cooperative commission
          environment. This means that the seller&apos;s Realtor will have a
          contractual agreement with the seller that includes a total commission
          amount. The seller&apos;s Realtor then offers a portion of that
          commission amount to be shared with any buyer&apos;s Realtor that
          produces a prospective buyer and results in a successful purchase of
          the home. There are no standard commission rates or arrangements, but
          an example would be a seller agreeing to pay their Realtor 6 – 7% of
          the gross sales price, and the seller&apos;s Realtor compensating the
          buyer&apos;s Realtor half of that amount, essentially 3 – 3.5% of the
          gross sales price.
        </p>
        <strong>How does the Kief Realty commission rebate work?</strong>
        <p>
          Whether purchasing a home listed on the market, or sometimes even a
          For Sale By Owner, your Kief Realty buyer&apos;s agent will be
          compensated by the seller&apos;s broker or the seller. From that
          compensation, we are simply sharing $250 with you. Although we hope
          you feel that Kief Realty has provided you with many benefits and
          value throughout your home buying experience, this is our modest way
          of saying thank you for your commitment and trust in us to play a part
          in one the greatest financial decisions of your life.
        </p>
        <p style={{ fontSize: '90%', color: 'rgb(180,185,190)' }}>
          *Rebates are permitted in Illinois, but not in all states. Flat $250
          rebate granted upon successful home purchase. Subject to minimum
          commission of $2,500. May be subject to lender approval if applied
          toward closing costs. Not offered on short sale transactions.
        </p>
        <strong>I want to sell my house. Do I get a rebate?</strong>
        <p>
          Kief Realty does not currently offer rebates to sellers. However, if
          you hire us to sell your home and then also hire us to assist you in
          purchasing your next home, we will DOUBLE your buyer rebate.
          That&apos;s $500 big ones!
        </p>
      </Card>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ margin: '3rem 0' }}>
          Go Ahead and Spend It All in One Place
        </h1>
        <img
          alt="Rebate"
          src="/static/images/rebate-info.png"
          style={{ display: 'block', margin: '3rem auto', maxWidth: '100%' }}
        />
        <LinkButton
          style={{ textDecoration: 'none', margin: '3rem auto' }}
          onClick={openRebateTermsModal}
        >
          * Rebate Terms
        </LinkButton>
      </div>
    </div>
  </div>
)

export default connect(
  null,
  { openRebateTermsModal }
)(Rebate)



// WEBPACK FOOTER //
// ./src/views/Rebate/index.js